import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import style from './zippy.scss';

let id = 0;

@CSSModules(style)
export default class Zippy extends Component {
  static defaultProps = {
    md: "200px",
    background: "#ffffff",
    indentation: 0
  }

  state = {
    apply: true
  }

  getSize() {
    return document.body.getBoundingClientRect().width < 640 ? 'sm' : 'md';
  }

  componentDidMount() {
    const content = this.refs.content;
    const height = this.props[this.getSize()].replace('px', '');

    if (content.getBoundingClientRect().height <= height) {
      this.setState({ apply: false });
    } else {
      this.setState({ height: this.props.md });
    }
  }

  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`;
  }

  get id() {
    this._id = this._id || "id-" + ++id;
    return this._id;
  }

  render() {
    let content;

    if (this.state.apply) {
      const id = `input-${this.id}`;
      const background = this.hexToRgb(this.props.background);

      content = (
        <div styleName="root">
          <input
            id={id}
            ref="more"
            type="checkbox"
            styleName="more"
          />

          <div ref="content" styleName="content" style={{ maxHeight: this.state.height }}>
            {this.props.children}
            <div styleName="extraMargin" />
          </div>

          <style
            dangerouslySetInnerHTML={{
              __html: `
                #${id}:before {
                  background: linear-gradient(rgba(${background}, 0), rgba(${background}, 0.9));
                }
                #${id}:after {
                  background: linear-gradient(rgba(${background}, 0.9), rgba(${background}, 1));
                  padding-left: ${this.props.indentation}px
                }
              `}}
          />
        </div>
      )
    } else {
      content = this.props.children;
    }

    return content;
  }
}



// WEBPACK FOOTER //
// ./src/components/common/zippy.js